'use strict';

angular.module('emailTemplates.components.emailTemplatesContainer', [
  'emailTemplates.components.emailTemplatesClient'
]).component('emailTemplatesContainer', {
  templateUrl: '/Scripts/app/emailTemplates/components/email-templates-container.template.html',
});